export const attachTooltip = "c$a";
export const insertTooltip = "d$a";
export default {attachTooltip,insertTooltip};